module.exports = __webpack_public_path__ + "56d66b6d90750b5d7d687cceef965c53.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/welcome-images/images/welcome-diamond@2x.png
// module id = 802
// module chunks = 0